/*
 * Authors: mariushirjanu
 * Created: 03/01/2023
 */
import * as _ from 'underscore';
import { Subscription } from 'rxjs';
import { trackByFunction } from '../../../../shared/formly/ga-formly.util';
import { UntypedFormGroup } from '@angular/forms';
import { Component, Input, Output, EventEmitter, SimpleChanges, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { ICatalogLayout, OrderCatalogService } from '../order-catalog.service';
import { ResponsiveService } from '../../../../shared/responsive/responsive.service';
import { BreakpointsService } from '../../../../shared/services/breakpoints.service';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { CatalogOverviewService } from './catalog-overview.service';
import { FieldBuilder, GaFormlyService, IExtraFieldConfigurationObject, OnChangeHandler } from '../../../../shared/formly/ga-formly.service';
import { ICatalogSearchParam } from './order-catalog-overview.component';
import { INamedStringObject, IObject } from '../../../../../type_definitions/datatypes';
import { ResizeService } from '../../../../shared/services/resize.service';
import { util } from '../../../../shared/util';
import { OrderCatalogDataService } from '../order-catalog-data.service';
import { CatalogOverviewFiltersUtilService } from './catalog-overview-filters-util.service';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { GaEventService, IGAEvent } from '../../../../shared/services/ga-event.service';
import { EVENT_ORDER_CURRENCY_CHANGED } from '../../../../shared/app-events';

import { MAIN_CONTAINER_ELEMENT } from '../../../main.component';

@Component({
  selector: 'catalog-filters',
  template: `
      <div class="sidebar" *ngIf="((!smallScreen && showFilter) || (smallScreen && showMobileFilter))">
        <div class="filters-title" (click)="showMobileFilter = !showMobileFilter">
          <span translate>CATALOG.FILTERS.TITLE</span> <i class="fa fa-chevron-up"></i>
        </div>
        <formly [form]="filterForm" [fields]="filterFormFields" [model]="searchParams" [noValidate]="true"></formly>
        <formly *ngIf="dynamicFiltersFields?.length" [form]="dynamicFiltersForm" [fields]="dynamicFiltersFields" [model]="dynamicFiltersModel" [noValidate]="true"></formly>
      </div>
    
      <div [ngClass]="!showFilter || smallScreen ? 'row' : 'd-block'">
        <div class="item-list" [ngClass]="{'col-sm-12': !showFilter || smallScreen, 'horizontal-scrollable': selectedLayout.name === 'tab-basic'}" scrollTarget="results-top" scrollPaddingTop="15">
          <div class="clearfix">
            <div class="filters-result clearfix" *ngIf="hasSelectedFilters" [ngClass]="selectedLayout.name">
              <a class="filter-selected btn btn-primary" (click)="removeFilter()" translate>CATALOG.FILTERS.REMOVE_FILTERS
                <span class="remove">
                <i class="fa fa-remove"></i>
              </span>
              </a>
              <a class="filter-selected btn btn-default" *ngIf="searchParams.pmin || searchParams.pmax" (click)="removeFilter('price')">
                <span translate>CATALOG.FILTERS.PRICE</span>:
                <span *ngIf="searchParams.pmin">
                <span translate>GA.FORM.FROM</span> {{searchParams.pmin}}
              </span>
                <span *ngIf="searchParams.pmax">
                <span translate>GA.FORM.TO</span> {{searchParams.pmax}}
              </span>
                {{currency}}
                <span class="remove">
                <i class="fa fa-remove"></i>
              </span>
              </a>
              <a class="filter-selected btn btn-default" *ngIf="searchParams.instock && showStock" (click)="removeFilter('instock')" translate>
                CATALOG.FILTERS.ONLY_IN_STOCK
                <span class="remove">
                <i class="fa fa-remove"></i>
              </span>
              </a>

              <ng-container *ngFor="let selectedFilter of searchParams.selectedFilters | keyvalue; trackBy: trackByFunction">
                <a *ngIf="selectedFilter.value.length !== 0" class="filter-selected btn btn-default" (click)="removeFilter(selectedFilter.key)">
                  {{selectedFilter.key}}
                  <span class="remove">
                  <i class="fa fa-remove"></i>
                </span>
                </a>
              </ng-container>
            </div>

            <div class="filters-trigger" *ngIf="smallScreen" (click)="showMobileFilter = !showMobileFilter">
              <span translate>CATALOG.FILTERS.TITLE<i class="fa fa-chevron-down"></i></span>
            </div>

            <div *ngIf="!showFilter && !smallScreen">
              <div class="row">
                <div class="col-md-8">
                  <formly [form]="filterInlineForm" [fields]="filterInlineFormFields" [model]="searchParams" [noValidate]="true" class="form-horizontal"></formly>
                </div>
                <div class="col-md-4">
                  <ng-content></ng-content>
                </div>
              </div>
            </div>

            <div *ngIf="smallScreen">
              <ng-content></ng-content>
            </div>

          </div>
        </div>
      </div>
  `
})
export class CatalogFiltersComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public searchParams:ICatalogSearchParam;
  @Input() public selectedLayout:ICatalogLayout;
  @Input() public filterCounts:IObject;
  @Output() public onModifySearch:EventEmitter<void> = new EventEmitter<void>();
  @Output() public onFiltersVisibility:EventEmitter<boolean> = new EventEmitter<boolean>();

  public filterForm:UntypedFormGroup = new UntypedFormGroup({});
  public filterInlineForm:UntypedFormGroup = new UntypedFormGroup({});
  public dynamicFiltersForm:UntypedFormGroup = new UntypedFormGroup({});
  public filterFormFields:IExtraFieldConfigurationObject[];
  public filterInlineFormFields:IExtraFieldConfigurationObject[];
  public dynamicFiltersFields:IExtraFieldConfigurationObject[];
  public sortOptions:INamedStringObject[];
  public possibleLayouts:ICatalogLayout[];
  public trackByFunction:Function = trackByFunction;
  public showFilter:boolean;
  public showStock:boolean;
  public smallScreen:boolean;
  public xSmallScreen:boolean;
  public showMobileFilter:boolean = false;
  public hasSelectedFilters:boolean;
  public filters:IObject[];
  public currency:string;
  public dynamicFiltersModel:{} = {};
  private eventHandler:Subscription;

  constructor(
    private formlyService:GaFormlyService,
    private orderCatalogService:OrderCatalogService,
    private catalogOverviewService:CatalogOverviewService,
    private responsiveService:ResponsiveService,
    private breakpointsService:BreakpointsService,
    private formattingService:FormattingService,
    private resizeService:ResizeService,
    private orderCatalogDataService:OrderCatalogDataService,
    private catalogOverviewFiltersUtilService:CatalogOverviewFiltersUtilService,
    private translationService:TranslationService,
    private gaEventService:GaEventService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.activate();
    this.listen();
  }

  private activate():void {
    this.sortOptions = this.catalogOverviewService.sortOptions;
    this.possibleLayouts = this.catalogOverviewService.possibleLayouts;
    this.currency = this.orderCatalogService.currency;
    this.showStock = this.orderCatalogService.showStock;
    this.orderCatalogService.isStarted()
      .then(() => {
        this.loadFilters();
      })
      .catch(util.noop);
    this.filterFormFields = this.createFilterFormFields();
    this.filterInlineFormFields = this.createFilterFormFields(true);
    this.sizeUpdate();
  }

  private listen():void {
    this.resizeService.addResizeEventListener(MAIN_CONTAINER_ELEMENT, () => {
      this.sizeUpdate();
    });

    this.eventHandler = this.gaEventService.events.subscribe((event:IGAEvent) => {
      if(event.name === EVENT_ORDER_CURRENCY_CHANGED){
        this.currency = event.data;
      }
    });
  }

  private createFilterFormFields(inline?:boolean):IExtraFieldConfigurationObject[] {
    const fields:IExtraFieldConfigurationObject[] = [];

    const priceGroupField:FieldBuilder = this.formlyService.aGroup(undefined, 'CATALOG.FILTERS.PRICE')
        .withWrapperClass(`col-md-${!inline ? '12' : '4'} price-group`)
        .withLabelClass('col col-auto')
        .withFields([
          this.formlyService.anInput('pmin')
            .withoutWrapper()
            .withWrapperClass('col-md-5 col-price')
            .withPlaceholder('GA.FORM.MIN')
            .onBlur(this.modifySearchListener)
            .build(),

          this.formlyService.aTemplate(`<span translate>${this.translationService.instant('GA.FORM.TO')}</span>`)
            .withWrapperClass('col-md-2 text-center')
            .build(),

          this.formlyService.anInput('pmax')
            .withoutWrapper()
            .withWrapperClass('col-md-5 col-price')
            .withPlaceholder('GA.FORM.MAX')
            .onBlur(this.modifySearchListener)
            .build()
        ])
        .withExtraOptions({
          templateOptions: {
            fieldGroupWrapperClass: 'g-0'
          }
        });

      const inStockCheckboxField:FieldBuilder = this.formlyService.aCheckbox('instock', 'CATALOG.FILTERS.ONLY_IN_STOCK_LONG')
        .withoutWrapper()
        .onChange(this.modifySearchListener)
        .withHideExpression(() => !this.showStock);


    if(!inline){
      fields.push(
        this.formlyService.aTemplate(`<h3>${this.translationService.instant('CATALOG.FILTERS.PRICE')}</h3>`)
          .build(),

        priceGroupField
          .withoutWrapper()
          .build(),

        this.formlyService.aTemplate(`<h3>${this.translationService.instant('CATALOG.FILTERS.IN_STOCK')}</h3>`)
          .withHideExpression(() => !this.showStock)
          .build(),

        inStockCheckboxField
          .build()
      );
    } else {
      fields.push(
        priceGroupField
          .build(),

        inStockCheckboxField
          .withWrapperClass('col-md-6')
          .build()
      );
    }

    return fields;
  }

  public ngOnChanges(changesObj:SimpleChanges):void {
    if (changesObj.searchParams) {
      this.searchParams = changesObj.searchParams.currentValue;
      this.setDynamicFilters(this.searchParams.selectedFilters);
    }
  }

  private createDynamicFiltersFields():IExtraFieldConfigurationObject[] {
    const fields:IExtraFieldConfigurationObject[] = [];

    _.each(this.filters, (filter:IObject) => {
      const options:IExtraFieldConfigurationObject[] = [
        this.formlyService.aTemplate(`<h3>${filter.name}</h3>`)
          .build()
      ];

      _.each(filter.possibleValues, (option:string) => {
        options.push(
          this.formlyService.aCheckbox(`${filter.name}.${option}`, option)
            .withoutWrapper()
            .withFormat((value:string) => this.formatFilter(filter.name, value))
            .withDisableExpression((value:string) => this.disabledFilter(filter.name, value))
            .onChange((checked:boolean) => this.changeDynamicFilter(filter.name, option, checked))
            .build()
        );
      });

      fields.push(
        this.formlyService.aGroup()
          .withoutWrapper()
          .withWrapperClass('col-md-12 filter')
          .withFields(options)
          .build()
      );
    });

    return fields;
  }

  private loadFilters():void {
    if (this.searchParams && this.searchParams.selectedCategoryName !== 'All') {
      this.orderCatalogDataService.filters(this.searchParams.selectedCategoryName)
        .then((filters:IObject[]) => {
          this.setFilters(filters);
          //initialize empty arrays for filters that don't exist yet
          _.forEach(this.filters, (filter:any) => {
            if (!this.searchParams.selectedFilters[ filter.name ]) {
              this.searchParams.selectedFilters[ filter.name ] = [];
            }
          });
        })
        .catch(() => {
          this.clearFilters();
        })
        .finally(() => {
          this.showHideFilters();
          this.hasSelectedFilters = this.hasSelectedFiltersOrParams();
        });

    } else {
      this.clearFilters();
      this.showHideFilters();
    }
  }

  private setFilters(filters:IObject[]):void {
    this.filters = filters;
    this.dynamicFiltersFields = this.createDynamicFiltersFields();
  }

  private setDynamicFilters(filters):void {
    _.each(filters, (options:string[], filter:string) => {
      this.dynamicFiltersModel[filter] = this.dynamicFiltersModel[filter] || {};
      if(options?.length){
        _.each(options, (option:string) => {
          this.dynamicFiltersModel[filter][option] = true;
        });
      }
    });
  }

  private clearFilters():void {
    this.filters = [];
    this.dynamicFiltersFields = [];
  }

  private hasSelectedFiltersOrParams():boolean {
    if (this.searchParams.pmin || this.searchParams.pmax || this.searchParams.instock) {
      return true;
    }

    return this.catalogOverviewFiltersUtilService.containsSelection(this.searchParams.selectedFilters);
  }

  private sizeUpdate():void {
    const currentBP:string = this.breakpointsService.current();
    this.xSmallScreen = currentBP === 'xs';
    this.smallScreen = (currentBP === 'xs' || currentBP === 'sm');
  }

  private showHideFilters():void {
    this.showFilter = this.filters.length > 0;
    this.onFiltersVisibility.emit(this.showFilter);
  }

  private modifySearchListener:OnChangeHandler = ():void => {
    this.onModifySearch.emit();
  };

  private changeDynamicFilter(filter:string, option:string, checked:boolean){
    if(checked && !_.contains(this.searchParams.selectedFilters[filter], option)){
      this.searchParams.selectedFilters[filter].push(option);
    } else {
      this.searchParams.selectedFilters[filter] = _.without(this.searchParams.selectedFilters[filter], option);
    }

    this.modifySearchListener();
  }

  private formatFilter(name:string, value:string):string {
    const count = this.filterCounts[ name ]? this.filterCounts[ name ][ value ] : undefined;
    if (util.isNullOrUndefined(count)) {
      return value;
    } else {
      return `${value} (${count})`;
    }
  }

  private disabledFilter(name:string, value:string):boolean {
    const count = this.filterCounts[ name ]? this.filterCounts[ name ][ value ] : undefined;
    return count === 0;
  }

  public removeFilter(filter?:string):void {
    if (filter) {
      if (filter === 'price') {
        this.searchParams.pmin = undefined;
        this.searchParams.pmax = undefined;
      } else if (filter === 'instock') {
        this.searchParams.instock = undefined;
      } else {
        this.searchParams.selectedFilters[ filter ] = [];
      }
    } else {
      const resetFilters:IObject = {};
      _.each(this.searchParams.selectedFilters, (v, k) => {
        resetFilters[ k ] = [];
      });
      this.searchParams.selectedFilters = resetFilters;
      this.searchParams.pmin = undefined;
      this.searchParams.pmax = undefined;
      this.searchParams.instock = undefined;
      this.showMobileFilter = false;
    }
    this.modifySearchListener();
  }

  public ngOnDestroy():void {
    this.resizeService.removeResizeEventListener(MAIN_CONTAINER_ELEMENT);
    this.eventHandler?.unsubscribe();
  }
}